let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("izzBN")).then(() => parcelRequire('fzCrs'));